import {
    AnalyticsCTAEvent,
    useTrackCTAClickedAnalytics,
} from '@/utils/amplitude/analytics/cta/trackCTAClicked.analytics';
import { getConsignmentsSellerUrl } from '@/utils/urls';
import { getItemSummaryCatalogId, getItemSummarySellerId } from '@/redux/modules/item/summary/itemSummary.selectors';
import { openWaitingForApprovalModal } from '@/redux/modules/modal';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

type LinkType = 'tips_for_winning' | 'tips_for_getting_approved' | 'sell_similar_item';

type Props = {
    itemId: number;
};

export const useHandleLinkClicked = ({ itemId }: Props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const sellerId = useAppSelector((state) => getItemSummarySellerId(state, itemId));
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const trackCTAClickedAnalytics = useTrackCTAClickedAnalytics();

    const showWaitingForApprovalModal = useCallback(() => {
        dispatch(openWaitingForApprovalModal(catalogId));
    }, [dispatch, catalogId]);

    return useCallback(
        (type: LinkType) => {
            switch (type) {
                case 'tips_for_winning':
                    window.open(
                        'https://help.liveauctioneers.com/hc/en-gb/articles/24550839031057-Tips-for-winning',
                        '_blank'
                    );
                    break;
                case 'tips_for_getting_approved':
                    showWaitingForApprovalModal();
                    break;
                case 'sell_similar_item':
                    trackCTAClickedAnalytics(AnalyticsCTAEvent.PriceResultsPage.SellSimilarItem);
                    navigate(getConsignmentsSellerUrl(sellerId));
                    break;

                default:
                    break;
            }
        },
        [navigate, sellerId, showWaitingForApprovalModal, trackCTAClickedAnalytics]
    );
};
